export class GuidHelper {
  private static guidValidationRegex: RegExp = new RegExp(/^\{?[0-9a-fA-F]{8}\-([0-9a-fA-F]{4}\-){3}[0-9a-fA-F]{12}\}?$/i);

  public static IsValid(guid: string): boolean {
    return guid != undefined && guid != null && GuidHelper.guidValidationRegex.test(guid);
  }
}
